import * as React from 'react'
import {Component, Fragment} from 'react'
import {findDOMNode} from 'react-dom'

///////////////////////////////////////////////////////////////////////////////

export type SelectWrapperProps = {
  children?: any
}

///////////////////////////////////////////////////////////////////////////////

export class SelectWrapper extends Component<SelectWrapperProps, any> {
  private select: HTMLSelectElement
  private formBlock: HTMLElement
  private fieldBlock: HTMLElement

  componentDidMount() {
    this.select = findDOMNode(this) as HTMLSelectElement
    this.formBlock =
      this.select &&
      ((this.select as HTMLElement).closest('.form-block') as HTMLElement)
    this.fieldBlock =
      this.select &&
      ((this.select as HTMLElement).closest('.field-block') as HTMLElement)

    let {select, formBlock} = this

    if (select) {
      if (formBlock) {
        formBlock.classList.add('select-wrapper')
      }

      this.insertSelectArrow()
    }
  }

  insertSelectArrow() {
    let {fieldBlock} = this

    if (fieldBlock) {
      let iconsBlock = fieldBlock.querySelector('.icons-block') as HTMLElement

      if (!iconsBlock) {
        iconsBlock = document.createElement('div')
        iconsBlock.classList.add('icons-block')
        fieldBlock.appendChild(iconsBlock)
      }

      let selectArrow = iconsBlock.querySelector('md-select-arrow')

      if (!selectArrow) {
        selectArrow = document.createElement('div')
        selectArrow.classList.add('md-select-arrow')

        let arrowInner = document.createElement('div')
        arrowInner.classList.add('md-select-arrow-inner')

        selectArrow.appendChild(arrowInner)
        iconsBlock.appendChild(selectArrow)
      }
    }
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>
  }
}
